import { Grid } from '@mui/material';
import { ITransactionsData } from '@interfaces/transactions';
import { FONTS_WEIGHTS } from "src/global/theme/fonts";
import TableHeader from "src/components/TableHeader";

import ListTransactions from '../ListTransactions';

import { COLUMN_WIDTHS } from './columns';
import { stylesList } from './styles';

interface Props {
  transactions: ITransactionsData[];
}

const TableListTransactions = ({ transactions }: Props) => {
  const { classes } = stylesList();

  // Orden definitivo H5: ID → Fecha y hora → Terminal → Monto → Tipo → Bandera → Banco → Estado.
  const TABLE_HEADERS = [
    { id: 1, name: 'ID transacción', xs: COLUMN_WIDTHS.id },
    { id: 2, name: 'Fecha y hora', xs: COLUMN_WIDTHS.date },
    { id: 3, name: 'Terminal', xs: COLUMN_WIDTHS.terminal },
    { id: 4, name: 'Monto', xs: COLUMN_WIDTHS.amount },
    { id: 5, name: 'Tipo', xs: COLUMN_WIDTHS.type },
    { id: 6, name: 'Bandera', xs: COLUMN_WIDTHS.brand },
    { id: 7, name: 'Banco', xs: COLUMN_WIDTHS.bank },
    { id: 8, name: 'Estado', xs: COLUMN_WIDTHS.status },
    { id: 9, name: '', xs: COLUMN_WIDTHS.actions }
  ];

  return (
    <Grid container>
      <Grid container className={classes.tableContainer}>
        <Grid item xs={12}>
          <TableHeader
            tableHeaders={TABLE_HEADERS}
            textAlign="center"
            whiteSpace={'nowrap'}
            overflow={'visible'}
            fontWeight={FONTS_WEIGHTS.SEMIBOLD}
          />
          <ListTransactions data={transactions} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TableListTransactions;
